import React, { useEffect, useState, useMemo } from 'react';
import { Link, useLocation, useHistory } from 'react-router-dom';
import CardContainer from '../../components/card/card-container.jsx';
import ListToolbar, { BtnNuevo, BtnSecundario, BtnEliminar } from '../../nuup/componentes/Toolbar/ListToolbar.jsx';
import LabelNumber from '../../components/label/label-number.jsx';
import Api from '../../api/global.service';

import NoPagination from '../../components/pagination/noPagination.jsx';
import SearchColumn from '../../components/search/search-column.jsx';
import FormSelectMaterial from '../../nuup/componentes/Forms/FormSelectMaterial.jsx';
import transformWord from '../../utils/transformWord.js';
import useEtiquetas from '../../hooks/useEtiquetas.jsx';
import BlockUi from 'react-block-ui';
import env from '../../environment.js';
import { isMiel, useCoopConfig } from '../../components/content/coop-config.jsx';
import LabelEudr from '../../components/label/label-eudr.jsx';
import insertIf from '../../utils/insertIf.js';
import SelectCiclo from '../../components/select/select-ciclo.jsx';
import BackButton from '../../components/link/back-button.jsx';
import getGeolicalizedLabel from '../../utils/getGeolicalizedLabel.js';
import { useAuth } from '../../components/content/auth.jsx';
import ModalParcelasDownload from '../../components/modal/modal-parcelas-download.jsx';
import riesgoEudrCalculator from '../../nuup/utils/riesgoEudrCalculator.js';
import getRiesgoEudrLabel from '../../nuup/utils/getRiesgoEudrLabel.js';

// pareclas modals
import ModalAddParcela from '../../components/modal/modal-parcela-form';
import ModalBajaParcela from '../../components/modal/modal-parcela-bajas';

import ROLES from '../../constants/Roles.js';

const FILTER = {
  ALL: 0,
  WITH_POLYGON: 1,
  ONLY_CENTROID: 2,
  NO_GEO: 3,
};

const ParcelasList = () => {
  const [data, setData] = useState([]);
  const [originalData, setOriginalData] = useState([]);
  const [geoData, setGeoData] = useState([]);
  const [geoFilter, setGeoFilter] = useState(0);
  const [blocking, setBlocking] = useState(true);
  const [ciclo, setCiclo] = useState({});
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [formModalOpen, setFormModalOpen] = useState(false);
  const [formMode, setFormMode] = useState('create');
  const [selectedParcelaId, setSelectedParcelaId] = useState(null);
  const [selectedParcela, setSelectedParcela] = useState(null);
  const { search } = useLocation();
  const history = useHistory();
  const searchParams = useMemo(() => new URLSearchParams(search), [search]);
  const { etiquetas } = useEtiquetas();
  const coopConfig = useCoopConfig();

  const [bajaModalOpen, setBajaModalOpen] = useState(false);

  const [catalogosBaja, setCatalogosBaja] = useState(null);
  const [cuentasProductores, setCuentasProductores] = useState([]);
  const auth = useAuth();

  const columns = React.useMemo(
    () => [
      {
        Header: '',
        accessor: 'selector',
        sortable: false,
        width: 50,
        Cell: ({ row }) => {
          const currentId = row.original.uuid || row.original.id;
          const isChecked = String(selectedParcelaId) === String(currentId);
          return (
            <div className="form-check">
              <input
                type="checkbox"
                className="form-check-input"
                style={{ width: '20px', height: '20px' }}
                checked={isChecked}
                onChange={() => {
                  if (isChecked) {
                    setSelectedParcelaId(null);
                    setSelectedParcela(null);
                  } else {
                    setSelectedParcelaId(currentId);
                    setSelectedParcela(row.original);
                  }
                }}
              />
            </div>
          );
        },
      },
      {
        Header: 'ID SIRIO',
        accessor: 'id',
        sortable: false,
        width: 65,
      },
      {
        Header: 'CÓDIGO',
        accessor: 'codigo',
        sortable: true,
        width: 65,
      },
      {
        Header: 'PRODUCTOR',
        accessor: 'cuenta',
        sortable: true,
        Cell: ({ row, value }) => (
          <Link
            to={{
              pathname: `/admin/cuentas/perfil/${row.original.cuenta_uuid}`,
            }}
            className="m-r-2"
            style={{ color: '#789D16' }}>
            <span>{value}</span>
          </Link>
        ),
      },
      {
        Header: 'NOMBRE ' + transformWord(etiquetas?.parcela, ['uppercase']),
        accessor: 'nombre',
        sortable: true,
        Cell: ({ row, value }) => (
          <Link to={{ pathname: `/admin/parcelas/perfil/${row.original.uuid}` }} className="m-r-2" style={{ color: '#789D16' }}>
            <span>{value}</span>
          </Link>
        ),
      },
      {
        Header: 'GEOLOCALIZADA',
        accessor: 'geoLabel',
        sortable: true,
      },
      {
        Header: 'MUNICIPIO',
        accessor: 'municipio',
        sortable: true,
      },
      {
        Header: 'COMUNIDAD',
        accessor: 'localidad',
        sortable: true,
      },
      {
        Header: 'SUPERFICIE (HA)',
        accessor: 'superficie',
        sortable: true,
        Cell: ({ value }) => {
          return <LabelNumber value={value} digits={2}></LabelNumber>;
        },
      },
      {
        Header: transformWord(etiquetas?.planta, ['plural', 'uppercase']) + ' TOTALES',
        accessor: 'plantas',
        sortable: true,
        Cell: ({ value }) => {
          return <LabelNumber value={value}></LabelNumber>;
        },
      },
      {
        Header: 'ALERTAS POLÍGONO',
        accessor: 'alertas_poligono',
        sortable: true,
        minWidth: 80,
        show: !isMiel(),
      },
      {
        Header: 'ÁREAS NATURALES',
        accessor: 'areas_naturales',
        sortable: true,
        minWidth: 80,
        show: !!+coopConfig.config?.usa_eudr,
      },
      {
        Header: 'RIESGO EUDR preliminar',
        accessor: 'riskLabelPreliminar',
        sortable: true,
        minWidth: 80,
        show: !!+coopConfig.config?.usa_eudr,
        Cell: ({ value }) => <LabelEudr riesgo={value} />,
      },
      {
        Header: 'RIESGO EUDR',
        accessor: 'riskLabel',
        sortable: true,
        minWidth: 80,
        show: !!+coopConfig.config?.usa_eudr,
        Cell: ({ value }) => <LabelEudr riesgo={value} />,
      },
    ],
    [etiquetas, selectedParcelaId, coopConfig]
  );

  const searchColumns = React.useMemo(
    () => [
      { value: 0, target: '', label: 'TODO' },
      { value: 10, target: 'id', label: 'ID SIRIO' },
      { value: 9, target: 'codigo', label: 'CÓDIGO' },
      { value: 1, target: 'cuenta', label: 'PRODUCTOR' },
      { value: 2, target: 'nombre', label: 'NOMBRE ' + transformWord(etiquetas?.parcela, ['uppercase']) },
      { value: 2, target: 'geoLabel', label: 'GEOLOCALIZADA' },
      { value: 3, target: 'municipio', label: 'MUNICIPIO' },
      { value: 4, target: 'localidad', label: 'LOCALIDAD' },
      { value: 5, target: 'superficie', label: 'SUPERFICIE (HA)' },
      {
        value: 6,
        target: 'plantas',
        label: transformWord(etiquetas?.planta, ['plural', 'uppercase']) + ' TOTALES',
      },
      // { value: 7, target: 'variedades', label: 'VARIEDADES' },
      ...insertIf(!isMiel(), { value: 7, target: 'alertas_poligono', label: 'ALERTAS POLÍGONO' }),
      ...insertIf(+coopConfig.config?.usa_eudr, {
        value: 8,
        target: 'areas_naturales',
        label: 'ÁREAS NATURALES',
      }),
      ...insertIf(+coopConfig.config?.usa_eudr, {
        value: 8,
        target: 'riskLabel',
        label: 'RIESGO EUDR',
      }),
      // { value: 6, target: 'ciclo', label: 'CICLO' },
    ],
    []
  );

  const getData = async id_ciclo => {
    setBlocking(true);
    Api.search('parcelas_all', {
      sort: [{ column: 'cuenta', sort: 'asc' }],
      filter: [{ column: 'id_ciclo', operator: '=', value: id_ciclo }],
      withPoly: auth?.user?.id_rol == ROLES.ADMIN,
    })
      .then(response => {
        const updatedData = response.data.map(item => {
          const geoLabel = getGeolicalizedLabel(item.poligono, item.centroide);
          const riskLabel = getRiesgoEudrLabel(
            riesgoEudrCalculator(
              item.poligono,
              item.id_riesgo_eudr_user,
              item.alertas_error_poligono_count,
              item.id_riesgo_eudr_whisp,
              item.areas_naturales_count
            )
          );
          const riskLabelPreliminar = getRiesgoEudrLabel(
            riesgoEudrCalculator(
              item.poligono,
              null,
              item.alertas_error_poligono_count,
              item.id_riesgo_eudr_whisp,
              item.areas_naturales_count
            )
          );
          return { ...item, geoLabel, riskLabel, riskLabelPreliminar };
        });
        setOriginalData(updatedData);
        const riskParam = searchParams.get('riskFilter');
        if (riskParam) {
          filterRisk(riskParam, updatedData);
        } else {
          const geoParam = searchParams.get('geoFilter');
          filterGeo(geoParam, updatedData);
        }
        setBlocking(false);
      })
      .catch(e => {
        // eslint-disable-next-line no-console
        console.log('error: ', e);
        setBlocking(false);
      });
  };

  const getCatalogosBaja = async () => {
    try {
      const response = await Api.getAll('sic/cat_parcelas_bajas');
      return response.data;
    } catch (error) {
      console.error('Error fetching catalogos baja:', error);
      return {
        motivos: [],
        destinos: [],
      };
    }
  };

  const getCuentasProductores = async id_ciclo => {
    try {
      const response = await Api.search('cuentas', {
        filter: [
          { column: 'id_ciclo', operator: '=', value: id_ciclo },
          { column: 'confirmado', operator: '=', value: 1 },
        ],
        sort: [{ column: 'clave_tx', sort: 'asc' }],
      });
      return Array.isArray(response.data) ? response.data : [];
    } catch (error) {
      console.error('Error fetching cuentas productores:', error);
      return [];
    }
  };

  useEffect(() => {
    if (ciclo.id) {
      getData(ciclo.id);
      getCatalogosBaja().then(data => setCatalogosBaja(data));
      getCuentasProductores(ciclo.id).then(data => setCuentasProductores(data));
    }
  }, [ciclo]);

  const filterGeo = (filter, recievedData = null) => {
    const data = recievedData ? recievedData : originalData;
    searchParams.delete('riskFilter');
    if (filter == FILTER.WITH_POLYGON) {
      setGeoData(data.filter(item => item.geoLabel == 'polígono'));
      setData(data.filter(item => item.geoLabel == 'polígono'));
      setGeoFilter(FILTER.WITH_POLYGON);
      searchParams.set('geoFilter', FILTER.WITH_POLYGON);
      history.replace({
        search: searchParams.toString(),
      });
    } else if (filter == FILTER.ONLY_CENTROID) {
      setGeoData(data.filter(item => item.geoLabel == 'centroide'));
      setData(data.filter(item => item.geoLabel == 'centroide'));
      setGeoFilter(FILTER.ONLY_CENTROID);
      searchParams.set('geoFilter', FILTER.ONLY_CENTROID);
      history.replace({
        search: searchParams.toString(),
      });
    } else if (filter == FILTER.NO_GEO) {
      setGeoData(data.filter(item => item.geoLabel == 'sin geolocalizar'));
      setData(data.filter(item => item.geoLabel == 'sin geolocalizar'));
      setGeoFilter(FILTER.NO_GEO);
      searchParams.set('geoFilter', FILTER.NO_GEO);
      history.replace({
        search: searchParams.toString(),
      });
    } else {
      setGeoData(data);
      setData(data);
      setGeoFilter(FILTER.ALL);
      history.replace({ search: '' });
    }
  };

  const filterRisk = (filter, recievedData = null) => {
    const data = recievedData ? recievedData : originalData;
    if (filter) {
      setGeoData(data.filter(item => item.riskLabel == filter));
      setData(data.filter(item => item.riskLabel == filter));
      setGeoFilter(FILTER.ALL);
      searchParams.delete('geoFilter');
      searchParams.set('riskFilter', filter);
      history.replace({
        search: searchParams.toString(),
      });
    } else {
      setGeoData(data);
      setData(data);
      setGeoFilter(FILTER.ALL);
      history.replace({ search: '' });
    }
  };

  const productores = useMemo(() => {
    const unique = new Map();
    cuentasProductores.forEach(item => {
      const uuid = item.uuid;
      if (!uuid || unique.has(String(uuid))) return;
      unique.set(String(uuid), {
        uuid: String(uuid),
        value: String(uuid),
        id: item.id,
        id_cuenta: item.id,
        label: item.nombre,
        nombre: item.nombre,
      });
    });
    return Array.from(unique.values());
  }, [cuentasProductores]);

  const handleOpenCreate = () => {
    setFormMode('create');
    setSelectedParcela(null);
    setFormModalOpen(true);
  };

  const handleOpenEdit = () => {
    if (!selectedParcela) {
      window.alert(`Selecciona una ${transformWord(etiquetas?.parcela, ['singular', 'lowercase'])} para editar.`);
      return;
    }
    setFormMode('edit');
    setFormModalOpen(true);
  };

  const handleCloseFormModal = () => {
    setFormModalOpen(false);
  };

  const handleSubmitParcela = async payload => {
    try {
      setBlocking(true);

      if (formMode === 'edit' && selectedParcela) {
        await Api.update('admin/acopios/parcelas', selectedParcela.uuid, payload);
      } else {
        await Api.create('admin/acopios/crear_parcela', payload);
      }

      handleCloseFormModal();
      setSelectedParcela(null);
      setSelectedParcelaId(null);
    } catch (error) {
      console.error('Error asignando peso:', error);
      // setError(getApiError(error, 'Ocurrió un error al asignar el peso. Por favor, inténtalo de nuevo.'));
    } finally {
      getData(ciclo.id);
      setBlocking(false);
    }
  };

  const handleSubmitBajaParcela = async form => {
    try {
      setBlocking(true);
      const payload = {
        id_parcela: selectedParcela?.id,
        id_cat_parcelas_bajas: form.id_cat_parcelas_bajas,
        id_ciclo: ciclo.id,
      };
      await Api.create('sic/bajas_parcela_solicitud', payload);
      setBajaModalOpen(false);
      setSelectedParcela(null);
      setSelectedParcelaId(null);
    } catch (error) {
      console.error(`Error dando de baja la ${transformWord(etiquetas?.parcela, ['singular', 'lowercase'])}:`, error);
      // setError(getApiError(error, 'Ocurrió un error al dar de baja la parcela. Por favor, inténtalo de nuevo.'));
    } finally {
      getData(ciclo.id);
      setBlocking(false);
    }
  };

  useEffect(() => {
    if (!selectedParcelaId) return;
    const selected = data.find(item => String(item.uuid || item.id) === String(selectedParcelaId));
    if (!selected) {
      setSelectedParcela(null);
      setSelectedParcelaId(null);
    }
  }, [data, selectedParcelaId]);

  return (
    <div>
      <div className="row justify-content-between">
        <div className="col-6">
          <div className="d-flex">
            <BackButton goBackDefault="/dashboard" color="#789D16" border="0px" />
            <SelectCiclo setFilter={evt => setCiclo(evt?.target)} />
          </div>
        </div>
        <div className="col-3">
          <div className="d-flex justify-content-end">
            <button onClick={() => setIsModalOpen(true)} className={`btn m-r-2`} type="button" disabled={!ciclo?.id || blocking}>
              <img src={env.images.icon.xls} className="pr-1" />
              <span style={{ color: '#789D16', fontSize: '0.76rem' }}>Descargar Excel</span>
            </button>
          </div>
        </div>
      </div>
      <CardContainer height={'100%'}>
        <BlockUi tag="div" message="" blocking={blocking} renderChildren={true}>
          {/* Filtro de georreferenciación en su propio renglón, sobre el toolbar */}
          <div className="row justify-content-end">
            <div className="col-6 col-md-4 col-lg-3">
              <FormSelectMaterial
                id="geolocalizado"
                error={false}
                label="Georeferenciada"
                value={geoFilter}
                onChange={filterGeo}
                height={30}
                options={[
                  { value: 1, label: 'Con Polígono' },
                  { value: 2, label: 'Sólo centoide' },
                  { value: 3, label: 'Sin geolocalizar' },
                ]}
                showAll={true}
                showAllLabel="Todas"
              />
            </div>
          </div>

          <ListToolbar
            left={<SearchColumn data={geoData} columns={searchColumns} setDataFilter={evt => setData(evt)} clearSearchItem={geoFilter} />}>
            <BtnNuevo onClick={handleOpenCreate}>Agregar {transformWord(etiquetas?.parcela, ['capitalize'])}</BtnNuevo>
            <BtnSecundario onClick={handleOpenEdit} disabled={!selectedParcela}>
              Editar
            </BtnSecundario>
            <BtnEliminar onClick={() => setBajaModalOpen(true)} disabled={!selectedParcela}>
              Dar de baja
            </BtnEliminar>
          </ListToolbar>
        </BlockUi>

        <NoPagination blocking={blocking} columns={columns} data={data}></NoPagination>
      </CardContainer>

      <ModalParcelasDownload
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        idCooperativa={auth.user.id_cooperativa}
        idCiclo={ciclo?.id}
        data={data}
        etiquetas={etiquetas}
        coopConfig={coopConfig}
      />

      <ModalAddParcela
        isOpen={formModalOpen}
        handleClose={handleCloseFormModal}
        onSubmit={handleSubmitParcela}
        isEdit={formMode === 'edit'}
        parcela={selectedParcela}
        productores={productores}
        cuenta_uuid={selectedParcela?.cuenta_uuid}
        nombreProductor={selectedParcela?.cuenta}
        etiquetas={etiquetas}
      />

      <ModalBajaParcela
        isOpen={bajaModalOpen}
        handleClose={() => setBajaModalOpen(false)}
        onSubmit={handleSubmitBajaParcela}
        parcela={selectedParcela}
        catalogosBaja={catalogosBaja}
        etiquetas={etiquetas}
      />
    </div>
  );
};

export default ParcelasList;
